/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplicationDto } from '../models/ApplicationDto';
import type { CreateApplicationDto } from '../models/CreateApplicationDto';
import type { PaginatedApplicationListDto } from '../models/PaginatedApplicationListDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ApplicationsService {
  /**
   * 공고 지원하기
   * @returns ApplicationDto
   * @throws ApiError
   */
  public static applicationControllerCreateApplication({
    requestBody,
  }: {
    requestBody: CreateApplicationDto;
  }): CancelablePromise<ApplicationDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/applications',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * 내 신청 내역 가져오기
   * @returns PaginatedApplicationListDto
   * @throws ApiError
   */
  public static applicationControllerApplications({
    page,
    itemsPerPage,
  }: {
    page?: number;
    itemsPerPage?: number;
  }): CancelablePromise<PaginatedApplicationListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/applications',
      query: {
        page: page,
        itemsPerPage: itemsPerPage,
      },
    });
  }

  /**
   * 해당 공고의 내 신청 내역 가져오기
   * @returns ApplicationDto
   * @throws ApiError
   */
  public static applicationControllerApplicationsByPartTimeJob({
    partTimeJobId,
  }: {
    partTimeJobId: number;
  }): CancelablePromise<Array<ApplicationDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/part-time-jobs/{partTimeJobId}/applications',
      path: {
        partTimeJobId: partTimeJobId,
      },
    });
  }
}
